import React from 'react';
import PropTypes from 'prop-types';
import { Motion, spring } from 'react-motion';
import './styles.sass';
var RadialProgress = function RadialProgress(_ref) {
  var size = _ref.size,
    progress = _ref.progress,
    thickness = _ref.thickness,
    stroke = _ref.stroke,
    ringStroke = _ref.ringStroke,
    roundedLine = _ref.roundedLine;
  return /*#__PURE__*/React.createElement("div", {
    className: "RadialProgress"
  }, /*#__PURE__*/React.createElement("svg", {
    width: size + thickness * 2,
    height: size + thickness * 2,
    className: "RadialProgress__svg"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "RadialProgress__circle",
    cx: size / 2 + thickness,
    cy: size / 2 + thickness,
    r: size / 2,
    stroke: ringStroke,
    strokeWidth: thickness
  }), /*#__PURE__*/React.createElement(Motion, {
    defaultStyle: {
      progress: 0
    },
    style: {
      progress: spring(progress)
    }
  }, function (value) {
    return /*#__PURE__*/React.createElement("path", {
      className: "RadialProgress__path",
      strokeWidth: thickness,
      stroke: stroke,
      strokeLinecap: roundedLine ? 'round' : 'none',
      strokeDasharray: _progressToDasharray(value.progress, size),
      d: _path(size, thickness)
    });
  })));
};
RadialProgress.defaultProps = {
  size: 80,
  progress: 0,
  thickness: 5,
  stroke: '#40a0f4',
  ringStroke: '#eaeaea'
};
RadialProgress.propTypes = {
  size: PropTypes.number,
  progress: PropTypes.number,
  thickness: PropTypes.number,
  stroke: PropTypes.string,
  ringStroke: PropTypes.string,
  roundedLine: PropTypes.bool
};
export default RadialProgress;

/**
 * Generates a path based on size and stroke width.
 */
function _path(size, strokeWidth) {
  var half = size / 2;
  return "\n    M".concat(half + strokeWidth, " ").concat(strokeWidth, "\n    a ").concat(half, " ").concat(half, " 0 0 1 0 ").concat(size, "\n    a ").concat(half, " ").concat(half, " 0 0 1 0 -").concat(size, "\n  ");
}

/**
 * Calculates the correct dasharray to emulate the progress
 * effect.
 *
 * Explanation (for myself when I forget):
 * The trick is to set the length of each dash to
 * whatever % of the circumference we're at, and at the
 * same time make sure the gap between each stroke is far
 * enough so only a single one is displayed at any time.
 */
function _progressToDasharray(progress, size) {
  var circumference = size * Math.PI; // mmmm, could go for some pie
  // Length of the stroke
  var length = progress / 100 * circumference;
  // The gap which will make sure only a single "dash" is drawn.
  var gap = circumference - length;
  return "".concat(length, ",").concat(gap);
}
//# sourceMappingURL=index.js.map
